import React, { Component  } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Container, Row, Col, Form, Button, Card, Modal } from "react-bootstrap";
import { FaAngleDown } from 'react-icons/fa';
import moment from 'moment';
import Constants from '../lib/Constants';
import NewReport from "./NewReport";
import C from "../lib/Config";

export default class FollowupList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientId: this.props.patientId,
            context: this,
            reportModal: false,
            selectedApptReportData: null,
            reportMode: null,
            filteredFollowupReports: [],
            chemoSittingId: this.props.chemoSittingId || null,
            chemoSittingDate: null
        };
    }
    closeReportHandler = () => {
        this.setState({ reportModal: false, reportMode: null });
    }
    reportSavedSuccessHandler = () => {
        this.setState({ reportModal: false, reportMode: null, });
    }
    reportHandler = (mode, data) => {
        this.setState({
            reportModal: true,
            reportMode: mode,
            selectedApptReportData: data
        });
    }
    componentDidMount() {
        // If we have a chemoSittingId, fetch the chemo sitting details to get the date
        if (this.props.chemoSittingId) {
            this.fetchChemoSittingDetails(this.props.chemoSittingId);
        } else {
            // If no chemoSittingId, just use all followup reports
            this.setState({ filteredFollowupReports: this.props.followupReports || [] });
        }
    }

    componentDidUpdate(prevProps) {
        // If followupReports or chemoSittingId props change, update the filtered reports
        if (prevProps.followupReports !== this.props.followupReports || 
            prevProps.chemoSittingId !== this.props.chemoSittingId) {
            
            if (this.props.chemoSittingId && this.props.chemoSittingId !== prevProps.chemoSittingId) {
                this.fetchChemoSittingDetails(this.props.chemoSittingId);
            } else {
                this.filterFollowupReports();
            }
        }
    }

    fetchChemoSittingDetails = (chemoSittingId) => {
        fetch(`${C.getUrl()}/userCase/getChemoSittingDetails?chemoSittingId=${chemoSittingId}`)
            .then(response => response.json())
            .then(result => {
                let chemoSittingDate = null;
                
                if (result.data) {
                    chemoSittingDate = result.data.chemoDt;
                } else if (result.message) {
                    try {
                        const parsedData = JSON.parse(result.message);
                        if (parsedData) {
                            chemoSittingDate = parsedData.chemoDt;
                        }
                    } catch (e) {
                    }
                }
                
                this.setState({ chemoSittingDate }, this.filterFollowupReports);
            })
            .catch(error => {
                // If there's an error, just use all followup reports
                this.setState({ filteredFollowupReports: this.props.followupReports || [] });
            });
    }

    filterFollowupReports = () => {
        const { chemoSittingDate } = this.state;
        const followupReports = this.props.followupReports || [];
        
        if (!chemoSittingDate || followupReports.length === 0) {
            this.setState({ filteredFollowupReports: followupReports });
            return;
        }
        
        // Filter followup reports based on chemo sitting date
        const chemoDate = new Date(chemoSittingDate);
        
        // Find appointments that are within 7 days before or after the chemo sitting date
        const relevantAppointments = followupReports.filter(appointment => {
            const appointmentDate = new Date(appointment.appointmentDt);
            const daysDifference = Math.abs((appointmentDate - chemoDate) / (1000 * 60 * 60 * 24));
            return daysDifference <= 7; // 7-day window for relevance
        });
        
        if (relevantAppointments.length > 0) {
            // Sort by proximity to chemo sitting date
            relevantAppointments.sort((a, b) => {
                const dateA = new Date(a.appointmentDt);
                const dateB = new Date(b.appointmentDt);
                return Math.abs(dateA - chemoDate) - Math.abs(dateB - chemoDate);
            });
            
            this.setState({ filteredFollowupReports: relevantAppointments });
        } else {
            // If no relevant appointments found, show the most recent appointment as fallback
            const sortedAppointments = [...followupReports].sort(
                (a, b) => new Date(b.appointmentDt) - new Date(a.appointmentDt)
            );
            
            if (sortedAppointments.length > 0) {
                this.setState({ filteredFollowupReports: [sortedAppointments[0]] });
            } else {
                this.setState({ filteredFollowupReports: [] });
            }
        }
    }

    render() {
        const { showFollowupList, closeModal, appointmentId  } = this.props;
        const { reportMode, selectedApptReportData, reportModal, context, filteredFollowupReports }  = this.state;
        const closePreviewModal = () => {
            closeModal();
        }
        const dateFormat = 'DD/MM/yyyy';
        return (
            <div id="mySidepanel" className="sidepanel shadow-lg" show={showFollowupList ? "true" : "false"}>
                <Modal.Header closeButton onClick={() => closePreviewModal()} style={{ backgroundColor: '#7fd1ba6b', borderColor: '#7fd1ba6b' }}>
                    <Modal.Title>
                        <h3 className="fs-18 header_title mb-0 text-black">Previous Appointment Details</h3> 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid className='p-2'>
                        <Row>
                            <Col lg='12'>
                                <Accordion id="followupReport">
                                    {filteredFollowupReports
                                        .sort((a, b) => (new Date(b.appointmentDt)) - (new Date(a.appointmentDt)))
                                        .map(function (d, idx) {
                                            return (
                                                <Card key={idx} className="followup-Card">
                                                    <Accordion.Toggle className="followup-ReportCard mb-0 p-3" eventKey={idx + 1}><FaAngleDown className="fs-18 mr-1" />Appointment Date - {moment(d.appointmentDt, ['MMM DD, YYYY h:mm:ss A', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD']).format(dateFormat)}</Accordion.Toggle>
                                                    <Accordion.Collapse eventKey={idx + 1}>
                                                        <Card.Body>
                                                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                                                {/* <Form.Label column sm="4">
                                                                    Height
                                                                </Form.Label>
                                                                <Col sm="8">
                                                                    <p className='readOnlyView inline' readOnly >{d.height}</p>
                                                                </Col> */}
                                                                <Form.Label column sm="4">
                                                                    Weight
                                                                </Form.Label>
                                                                <Col sm="8">
                                                                    <p className='readOnlyView inline' readOnly >{d.weight} {d.weightUnitDto.unitName}</p>
                                                                </Col>
                                                                <Form.Label column sm="4">
                                                                    Adverse Effects
                                                                </Form.Label>
                                                                <Col sm="8">
                                                                    <p className='readOnlyView inline' readOnly >
                                                                        {typeof d.followupAdverseEffectDTOList !== 'undefined' && d.followupAdverseEffectDTOList.map(function (apt, index) {
                                                                            return (
                                                                                <li key={index}> {apt.reportParameterMstDTO.reportParamName} </li>
                                                                            )
                                                                        })}    
                                                                    </p>
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                                                <Form.Label column sm="4">
                                                                    Doctor Observations
                                                                </Form.Label>
                                                                <Col sm="8">
                                                                    <p className='readOnlyView inline' readOnly >{d.doctorObservation}</p>
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                                                <Form.Label column sm="4">
                                                                    Prescription
                                                                </Form.Label>
                                                                <Col sm="8">
                                                                    <p className='readOnlyView inline' readOnly >{d.doctorPrescription}</p>
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                                                <Form.Label column sm="4">
                                                                    Reports Submitted
                                                                </Form.Label>
                                                                <Col sm="8">
                                                                    <ul id='square'>
                                                                        {typeof d.appointmentReports !== 'undefined' && d.appointmentReports.map(function (apt, index) {
                                                                            return (
                                                                                <li key={index} className='squareList'>
                                                                                    <a className='text-primary font-w500' onClick={() => context.reportHandler(Constants.MODE_VIEW_REPORT, apt)}>
                                                                                        <h5>{apt.reportMasterDTO.reportName}</h5>
                                                                                    </a>
                                                                                </li>
                                                                            )
                                                                        })}
                                                                    </ul>
                                                                </Col>
                                                            </Form.Group>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            )
                                        })}
                                    </Accordion>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <NewReport show={reportModal} data={selectedApptReportData} mode={reportMode} appointmentId={appointmentId} closeModal={() => this.closeReportHandler()} reportSavedSuccess={() => this.reportSavedSuccessHandler()}/>
                </div>
        )
    }
}